import { BaseApiClient } from './base';
import { MembershipTierConfig } from '../../types';

export class MembershipConfigApi extends BaseApiClient {
  async getAllTiers(): Promise<MembershipTierConfig[]> {
    const data = await this.request('/admin/membership-tiers');
    return data.tiers;
  }

  async updateTier(tierId: string, config: Omit<MembershipTierConfig, 'tier_id'>): Promise<MembershipTierConfig> {
    const data = await this.request(`/admin/membership-tiers/${tierId}`, {
      method: 'PUT',
      body: JSON.stringify(config),
    });
    return data.tier;
  }
}

